module.exports = __webpack_public_path__ + "assets/img/error.dd16e8db.svg";